import DefaultSettings from '@/features/settings/components/templates/default-settings';

export const DefaultSettingsContainer = () => {
  return <DefaultSettings />;
};
